export const siteMeta = {
  name: '黑料专区',
  latin: 'HEILIAO',
  slogan: '今日猛料速递',
  issue: 'VOL. 024',
  dateText: '2026 年 9 月 10 日',
  weekday: '星期四',
  statement: '把散落全网的热议线索，整理成一期可以慢慢读完的猛料特刊。',
};

export const navLinks = [
  { id: 'nav-cover', label: '封面', href: '#cover' },
  { id: 'nav-today', label: '今日猛料', href: '#today' },
  { id: 'nav-latest', label: '最新爆料', href: '#latest' },
  { id: 'nav-people', label: '人物内幕', href: '#people' },
  { id: 'nav-talk', label: '热议现场', href: '#talk' },
];

export const coverFeature = {
  category: '本期头条',
  title: '一条被删了七分钟的通告，串起了整个剧组的沉默',
  excerpt:
    '通告单在凌晨两点被重新下发，取景地却临时改到备用棚。三个当事方的说法互相矛盾，我们按时间顺序把今日猛料重新拼了一遍。',
  image:
    'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20silhouette%20of%20an%20anonymous%20figure%20in%20a%20long%20coat%20under%20a%20dramatic%20warm%20spotlight%2C%20deep%20shadow%2C%20abstract%20blurred%20studio%20backdrop%20in%20muted%20cream%20and%20crimson%20tones%2C%20film%20grain%2C%20magazine%20cover%20aesthetic%2C%20high%20contrast%2C%20minimal%20composition&width=1000&height=1250&seq=hl-cover-01&orientation=portrait',
  author: '特刊组 · 阿栗',
  readTime: '6 分钟',
  comments: 1284,
  likes: 3207,
};

export const coverSideStories = [
  {
    id: 'side-1',
    tag: '代言',
    title: '品牌连夜撤下整组物料，只留下一句“档期调整”',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20still%20life%20of%20crumpled%20newspaper%20and%20a%20single%20red%20rose%20on%20warm%20cream%20paper%2C%20soft%20window%20light%2C%20muted%20tones%2C%20film%20grain%2C%20minimal%20magazine%20aesthetic&width=600&height=600&seq=hl-side-01&orientation=squarish',
    comments: 462,
    time: '1 小时前',
  },
  {
    id: 'side-2',
    tag: '饭局',
    title: '那场被拍到的深夜饭局，其实还有第三个人没进画面',
    image:
      'https://readdy.ai/api/search-image?query=Blurred%20night%20city%20street%20through%20rain%20covered%20glass%20with%20warm%20amber%20streetlights%2C%20abstract%20bokeh%2C%20moody%20editorial%20photography%2C%20film%20grain%2C%20muted%20red%20and%20gold%20tones&width=600&height=600&seq=hl-side-02&orientation=squarish',
    comments: 908,
    time: '3 小时前',
  },
  {
    id: 'side-3',
    tag: '录音',
    title: '流出的三十秒音频，前后被剪掉了两处呼吸声',
    image:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20an%20old%20vintage%20microphone%20on%20a%20dark%20wooden%20table%20with%20warm%20rim%20light%2C%20abstract%20soft%20background%20in%20cream%20and%20crimson%2C%20editorial%20magazine%20still%20life%2C%20film%20grain&width=600&height=600&seq=hl-side-03&orientation=squarish',
    comments: 231,
    time: '5 小时前',
  },
];

export const todayStories = [
  {
    id: 'today-1',
    category: '今日爆料',
    title: '官宣前夜突然撤档，宣传活动全部改为线上',
    excerpt:
      '原定线下见面会在开场前四小时被叫停，主办方给出的解释只更新了半句话。多位到场粉丝证实，现场连背景板都还没来得及拆。',
    image:
      'https://readdy.ai/api/search-image?query=Dramatic%20stage%20with%20a%20single%20bright%20spotlight%20and%20an%20empty%20chair%20in%20the%20center%2C%20heavy%20shadow%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20abstract%20editorial%20photography%2C%20film%20grain%2C%20minimal%20composition&width=1000&height=700&seq=hl-today-01&orientation=landscape',
    comments: 671,
    likes: 1544,
    time: '42 分钟前',
  },
  {
    id: 'today-2',
    category: '最新猛料',
    title: '一叠没有署名的信封，把旧事重新推回台面',
    excerpt:
      '信封上没有寄件人，只有统一的打印字体。知情者称其中两页是关键时间线，而这段记录此前从未在任何报道里出现过。',
    image:
      'https://readdy.ai/api/search-image?query=Stack%20of%20sealed%20envelopes%20and%20a%20magnifying%20glass%20on%20a%20warm%20cream%20desk%20under%20soft%20directional%20light%2C%20muted%20editorial%20still%20life%2C%20film%20grain%2C%20crimson%20accent%20detail&width=1000&height=700&seq=hl-today-02&orientation=landscape',
    comments: 389,
    likes: 977,
    time: '2 小时前',
  },
  {
    id: 'today-3',
    category: '劲爆话题',
    title: '现场粉丝其实听到了一句话，只是没人敢先发出来',
    excerpt:
      '隔着磨砂玻璃的那句回应，被不同角度的镜头录了三遍。三个版本的字幕略有出入，我们把它并排放在了一起。',
    image:
      'https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20crowd%20behind%20frosted%20glass%20with%20warm%20backlight%2C%20abstract%20figures%2C%20moody%20editorial%20photography%2C%20muted%20cream%20and%20crimson%20palette%2C%20film%20grain&width=1000&height=700&seq=hl-today-03&orientation=landscape',
    comments: 1203,
    likes: 2680,
    time: '4 小时前',
  },
];

export const latestLicks = [
  {
    id: 'lick-1',
    time: '09:12',
    tag: '首发',
    title: '剧组通告临时改动，原定夜戏整体顺延一天',
    source: '多方信源',
    hot: true,
  },
  {
    id: 'lick-2',
    time: '08:40',
    tag: '跟进',
    title: '品牌方账号悄悄取关，粉丝在超话里逐条比对',
    source: '网友整理',
    hot: false,
  },
  {
    id: 'lick-3',
    time: '07:55',
    tag: '爆料',
    title: '一段后台花絮被翻出，画面角落出现熟悉的身影',
    source: '独家线索',
    hot: true,
  },
  {
    id: 'lick-4',
    time: '06:30',
    tag: '回应',
    title: '工作室例行发文，全文没有提到事件的任何关键词',
    source: '公开渠道',
    hot: false,
  },
  {
    id: 'lick-5',
    time: '昨日 23:18',
    tag: '存档',
    title: '旧访谈被重新剪辑传播，原视频时长差了整整四分钟',
    source: '资料组',
    hot: false,
  },
];

export const peopleInsider = [
  {
    id: 'person-1',
    name: '当事人 A',
    role: '台前',
    teaser: '从配角到话题中心，只用了不到一周。她的团队至今没有对外定调。',
    followers: '热度 98.2 万',
    image:
      'https://readdy.ai/api/search-image?query=Anonymous%20portrait%20silhouette%20of%20a%20woman%20with%20long%20hair%20lit%20by%20a%20single%20warm%20side%20light%20against%20a%20plain%20cream%20backdrop%2C%20face%20in%20shadow%2C%20editorial%20magazine%20photography%2C%20film%20grain%2C%20muted%20tones&width=700&height=900&seq=hl-person-01&orientation=portrait',
  },
  {
    id: 'person-2',
    name: '幕后 B 先生',
    role: '资源',
    teaser: '被反复提到的“中间人”，据称手里握着几条未公开的沟通记录。',
    followers: '热度 76.5 万',
    image:
      'https://readdy.ai/api/search-image?query=Anonymous%20portrait%20silhouette%20of%20a%20man%20in%20a%20sharp%20suit%20with%20rim%20light%20against%20a%20plain%20warm%20beige%20backdrop%2C%20face%20obscured%20in%20shadow%2C%20editorial%20magazine%20photography%2C%20film%20grain&width=700&height=900&seq=hl-person-02&orientation=portrait',
  },
  {
    id: 'person-3',
    name: '神秘女伴',
    role: '变量',
    teaser: '只出现在监控时间线的最后一帧，身份成了评论区讨论最多的问题。',
    followers: '热度 61.3 万',
    image:
      'https://readdy.ai/api/search-image?query=Anonymous%20back%20portrait%20of%20a%20person%20in%20a%20silk%20dress%20standing%20in%20a%20softly%20lit%20corridor%2C%20blurred%20warm%20background%2C%20editorial%20fashion%20photography%2C%20film%20grain%2C%20muted%20cream%20and%20rose%20tones&width=700&height=900&seq=hl-person-03&orientation=portrait',
  },
];

export const hotTopics = [
  { rank: '01', title: '通告单改动时间线复盘', heat: '982万', trend: 'up' },
  { rank: '02', title: '被撤下的那组代言物料', heat: '761万', trend: 'up' },
  { rank: '03', title: '三十秒音频的真伪之争', heat: '540万', trend: 'flat' },
  { rank: '04', title: '深夜饭局里的第三人', heat: '418万', trend: 'up' },
  { rank: '05', title: '旧访谈被重新剪辑', heat: '236万', trend: 'down' },
];

export const hotComments = [
  {
    id: 'c1',
    user: '熬夜等猛料的猫',
    avatar:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20abstract%20avatar%20of%20a%20woman%20face%20in%20warm%20cream%20and%20crimson%20geometric%20shapes%2C%20editorial%20illustration%20style%2C%20clean%20background&width=200&height=200&seq=hl-avatar-01&orientation=squarish',
    text: '把三个版本的字幕并排放真的很有用，之前只看了一个片段就被带偏了。',
    time: '12 分钟前',
    likes: 486,
    replies: 32,
  },
  {
    id: 'c2',
    user: '只看时间线',
    avatar:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20abstract%20avatar%20of%20a%20man%20face%20in%20warm%20beige%20and%20amber%20geometric%20shapes%2C%20editorial%20illustration%20style%2C%20clean%20background&width=200&height=200&seq=hl-avatar-02&orientation=squarish',
    text: '建议把“多方信源”再标细一点，不然吃瓜吃到一半就断了。',
    time: '35 分钟前',
    likes: 213,
    replies: 11,
  },
  {
    id: 'c3',
    user: '理性围观',
    avatar:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20abstract%20avatar%20of%20a%20young%20person%20in%20warm%20taupe%20and%20red%20geometric%20shapes%2C%20editorial%20illustration%20style%2C%20clean%20background&width=200&height=200&seq=hl-avatar-03&orientation=squarish',
    text: '今天的排版看着舒服，留白多，读得下去，不像别处一打开全是广告。',
    time: '1 小时前',
    likes: 591,
    replies: 47,
  },
  {
    id: 'c4',
    user: '老瓜农',
    avatar:
      'https://readdy.ai/api/search-image?query=Minimal%20flat%20abstract%20avatar%20of%20an%20older%20man%20face%20in%20warm%20brown%20and%20cream%20geometric%20shapes%2C%20editorial%20illustration%20style%2C%20clean%20background&width=200&height=200&seq=hl-avatar-04&orientation=squarish',
    text: '记号一下，等后续更完整的时间线出来再回来看这一期。',
    time: '2 小时前',
    likes: 128,
    replies: 6,
  },
];

export const topicTags = [
  '今日猛料',
  '最新爆料',
  '今日黑料',
  '人物内幕',
  '猛料速递',
  '热议事件',
  '时间线复盘',
  '劲爆话题',
];

export const footerColumns = [
  {
    title: '内容分区',
    links: ['封面特刊', '今日猛料', '最新爆料', '人物内幕'],
  },
  {
    title: '速递服务',
    links: ['每日推送', '猛料存档', '话题订阅', '线索投稿'],
  },
  {
    title: '关于本站',
    links: ['编辑理念', '内容声明', '联系我们', '使用条款'],
  },
];